import React from 'react';
import PropTypes from 'prop-types';

const ToggleSwitch = ({
  id,
  name,
  checked,
  handleChange,
  labelText,
  optionalText,
  disabled,
}) => (
  <div className="form-check form-switch">
    {labelText && (
      <label className="form-check-label" htmlFor={id}>
        {labelText}
      </label>
    )}
    {optionalText && <div className="text-muted my-2">{optionalText}</div>}
    <input
      className="form-check-input toggle-switch"
      type="checkbox"
      id={id}
      name={name}
      checked={checked}
      onChange={() => handleChange(id)}
      disabled={disabled}
    />
  </div>
);

ToggleSwitch.defaultProps = {
  disabled: false,
};

ToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  handleChange: PropTypes.func,
  name: PropTypes.string,
  labelText: PropTypes.string,
  optionalText: PropTypes.string,
  disabled: PropTypes.bool,
};

export default ToggleSwitch;
